import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

import PageBar from '../../component/PageBar';
import { GetList, Update, Create, Delete, GetListDownload } from './http';
import download from 'downloadjs';

class List extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            newData: {
                title: '',
                name: '',
                class: '',
                phone: '',
            },
            search: {
                page: 1,
                size: 30,
                sort: '-id',
                status: 'OPENED',
                name: '',
            },
            totalPages: 20,
            total: 0,
        };

        const params = sessionStorage.getItem('manager_search');
        if (params) {
            this.state.search = JSON.parse(params);
        }

        this.reloadList(1);
    }

    reloadList = page => {
        const params = this.state.search;
        params.page = page;
        sessionStorage.setItem('manager_search', JSON.stringify(params));

        this.setState({
            search: params,
        });

        GetList(this, params, this.resultList.bind(this));
    };

    /**
     * 리스트
     */
    resultList = response => {
        this.setState({
            items: response.rows,
            totalPages: Math.ceil(response.range.total / response.range.size),
            total: response.range.total,
        });
    };

    /**
     * 등록
     * @param {*} e
     */
    clickAdd = e => {
        const { newData } = this.state;

        Create(this, newData, res => {
            alert('저장이 완료 되었습니다.');
            this.reloadList(1);
        });
    };

    /**
     * 수정
     * @param {*} item
     */
    clickSave = item => {
        Update(this, item.id, item, res => {
            alert('저장이 완료 되었습니다.');
            this.reloadList(this.state.search.page);
        });
    };

    /**
     * 삭제
     * @param {*} item
     */
    clickDelete = item => {
        Delete(this, item.id, res => {
            alert('삭제가 완료 되었습니다.');
            this.reloadList(this.state.search.page);
        });
    };

    render() {
        const { items, newData } = this.state;

        return (
            <div>
                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                <div className="search_box_2">검사원 관리</div>
                            </div>
                            <div className="rb"></div>
                        </div>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">검사원 정보 입력</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board">
                                        <colgroup>
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>정보</th>
                                                {/* <th>거래처명</th> */}
                                                <th>이름</th>
                                                <th>직위</th>
                                                <th>핸드폰</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>개인정보</td>
                                                {/* <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={newData.title}
                                                        onChange={e => {
                                                            newData.title = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td> */}
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={newData.name}
                                                        onChange={e => {
                                                            newData.name = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={newData.class}
                                                        onChange={e => {
                                                            newData.class = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <Form.Control
                                                        type={'text'}
                                                        value={newData.phone}
                                                        onChange={e => {
                                                            newData.phone = e.target.value;
                                                            this.setState({ newData });
                                                        }}
                                                    />
                                                </td>
                                                <td>
                                                    <button type="button" className="btn_02" onClick={this.clickAdd}>
                                                        입력저장
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className="board_top_box">
                            <div className="lb">
                                <div className="search_box_2">
                                    <input
                                        placeholder="이름을 입력하세요."
                                        type="text"
                                        class="form-control search01"
                                        onChange={e => {
                                            const search = this.state.search;
                                            search.name = e.target.value;
                                            this.setState({ search });
                                        }}
                                        value={this.state.search.name}
                                        onKeyPress={e => {
                                            if (e.key === 'Enter') {
                                                this.reloadList(1);
                                            }
                                        }}
                                    />
                                    <button class="btn_01 deep" onClick={e => this.reloadList(1)}>
                                        검색
                                    </button>
                                </div>
                            </div>

                            <div className="rb">
                                {/* <button title="검사원 생성하기" onClick={this.clickAdd} className="btn_02 red">
                                    <i className="feather icon-plus" /> 등록
                                </button> */}
                                <button
                                    type="button"
                                    className="btn_01 b_excel"
                                    onClick={e => {
                                        const params = this.state.search;

                                        GetListDownload(this, params, res => {
                                            download(atob(res), 'manager.xlsx', {
                                                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                            });
                                        });
                                    }}
                                >
                                    엑셀다운로드
                                </button>
                            </div>
                        </div>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h5">검사원 리스트</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <div className="table_board_box">
                                    <table className="tbl_board list bg">
                                        <colgroup>
                                            <col width="100" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col width="200" />
                                            <col />
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th>정보</th>
                                                {/* <th>거래처명</th> */}
                                                <th>이름</th>
                                                <th>직위</th>
                                                <th>핸드폰</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {items.map((x, idx) => (
                                                <tr>
                                                    {/* <td>{x.id}</td> */}
                                                    <td>{this.state.total - this.state.search.size * (this.state.search.page - 1) - idx}</td>

                                                    {/* <td>
                                                        <Form.Control
                                                            type={'text'}
                                                            value={x.title}
                                                            onChange={e => {
                                                                x.title = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td> */}
                                                    <td>
                                                        <Form.Control
                                                            type={'text'}
                                                            value={x.name}
                                                            onChange={e => {
                                                                x.name = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type={'text'}
                                                            value={x.class}
                                                            onChange={e => {
                                                                x.class = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Form.Control
                                                            type={'text'}
                                                            value={x.phone}
                                                            onChange={e => {
                                                                x.phone = e.target.value;
                                                                this.setState({});
                                                            }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn_02"
                                                            onClick={e => {
                                                                this.clickSave(x);
                                                            }}
                                                        >
                                                            수정저장
                                                        </button>
                                                        <div className="gab-w-40" />
                                                        <button
                                                            type="button"
                                                            className="btn_02 red"
                                                            onClick={e => {
                                                                this.clickDelete(x);
                                                            }}
                                                        >
                                                            목록 삭제
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="gab40"></div>

                                <div className="textRight">
                                    <PageBar nowPage={Number(this.state.search.page)} totalPage={this.state.totalPages} reload={this.reloadList} />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default List;
